// extracted by mini-css-extract-plugin
export var bubble = "_y-0";
export var container = "_y-f";
export var contrastBorder = "_y-g";
export var greyOut = "_y-2";
export var initialsColor0 = "_y-3";
export var initialsColor1 = "_y-4";
export var initialsColor10 = "_y-d";
export var initialsColor11 = "_y-e";
export var initialsColor2 = "_y-5";
export var initialsColor3 = "_y-6";
export var initialsColor4 = "_y-7";
export var initialsColor5 = "_y-8";
export var initialsColor6 = "_y-9";
export var initialsColor7 = "_y-a";
export var initialsColor8 = "_y-b";
export var initialsColor9 = "_y-c";
export var initialsWrapper = "_y-1";
export var large = "_y-l";
export var medium = "_y-k";
export var mediumSmall = "_y-j";
export var mediumSmallMedium = "_y-o";
export var micro = "_y-h";
export var small = "_y-i";
export var tiny = "_y-n";
export var xTiny = "_y-m";